import React from 'react';
import { Box, Typography } from "@mui/material";
import { ResendOtpProps } from '../../types';

const ResendOtp: React.FC<ResendOtpProps> = ({ canResend, resendTimer, onResend }) => (
  <Box sx={{ textAlign: 'center', mb: 2, mt: 4.5 }}>
    <Typography sx={{ fontSize: '14px', color: 'rgba(34, 43, 69, 0.6)' }}>
      Didn't receive OTP?{' '}
      <Box
        component="span"
        sx={{
          color: canResend ? 'rgba(44, 108, 160)' : 'rgba(34, 43, 69, 0.4)',
          cursor: canResend ? 'pointer' : 'default',
          textDecoration: canResend ? 'underline' : 'none'
        }}
        onClick={() => canResend && onResend()}
      >
        {canResend ? 'Resend' : <span>Resend in <span style={{ fontWeight: 'bold' }}>{resendTimer}s</span></span>}
      </Box>
    </Typography>
  </Box>
);

export default ResendOtp; 